import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components';
import { HomePage } from './HomePage';
import { HowItWorksPage } from './HowItWorksPage';
import { CareTeamsPage } from './CareTeamsPage';
import { PartnersPage } from './PartnersPage';
import { PatientsPage } from './PatientsPage';
import { TrustPage } from './TrustPage';
import { CompanyPage } from './CompanyPage';
import { PilotPage } from './PilotPage';
import { LoginPage } from './LoginPage';
import { NotFoundPage } from './NotFoundPage';
import './styles.css';

function App() {
  return <Layout><Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/how-it-works" element={<HowItWorksPage />} />
    <Route path="/care-teams" element={<CareTeamsPage />} />
    <Route path="/transplant-centers" element={<CareTeamsPage />} />
    <Route path="/partners" element={<PartnersPage />} />
    <Route path="/specialty-pharmacy" element={<PartnersPage />} />
    <Route path="/pharma" element={<PartnersPage />} />
    <Route path="/patients" element={<PatientsPage />} />
    <Route path="/trust" element={<TrustPage />} />
    <Route path="/security" element={<TrustPage />} />
    <Route path="/company" element={<CompanyPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/request-pilot" element={<PilotPage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes></Layout>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>);
